<!-- The actual authToken & checkoutId values must be provided for the form to initialize properly .
      - disableBankAccount / disableBnpl: these are optional (will NOT come into play unless the corresponding sub-components are there.
-->
<justifi-modular-checkout
  #justifiElem
  [attr.auth-token]="authToken"
  [attr.checkout-id]="checkoutId"
  disableBankAccount="true"
  disableBnpl="true"
  validationMode="onSubmit"
>
  <div class="card-form-container" data-form-type="card">
    <!-- Digital wallet buttons: stacked vertically (Apple Pay on top, Google Pay below).
         Agreement gating uses pointer-events + a semi-transparent overlay instead of opacity,
         because the pay buttons render inside iframes that ignore parent opacity on iOS.
         Google Pay is always rendered (no *ngIf) to avoid the 1-sec flash/disappear issue —
         its wrapper hides offscreen until googlePayVisible is set after initialization. -->

    <!-- Apple Pay: only on Safari/iOS. country-code drives Canadian vs US merchant behavior. -->
    <div *ngIf="showApplePay" style="position: relative;">
      <justifi-apple-pay
        disabled="true"
        [attr.country-code]="isCanada ? 'CA' : 'US'"
        [style.pointer-events]="isAgreementChecked ? 'auto' : 'none'">
      </justifi-apple-pay>
      <div *ngIf="!isAgreementChecked"
        style="position: absolute; inset: 0; background: rgba(220,220,220,0.75); border-radius: 6px; pointer-events: none;">
      </div>
    </div>

    <!-- Google Pay: always rendered in DOM (no *ngIf). Country/currency are inferred from the
         sub-account on JustiFi's side, so no per-component country attribute is needed.
         Before googlePayVisible is set, the wrapper is positioned offscreen so the component
         can initialize and run isReadyToPay. A ResizeObserver detects when the element gains
         height and flips googlePayVisible. -->
    <div [style.position]="googlePayVisible ? 'relative' : 'absolute'"
         [style.visibility]="googlePayVisible ? 'visible' : 'hidden'"
         style="overflow: hidden;"
         style="pointer-events: auto;">
      <justifi-google-pay
        [attr.merchant-display-name]="merchantName"
        style="display: block; width: 100%;"
        [style.pointer-events]="isAgreementChecked ? 'auto' : 'none'">
      </justifi-google-pay>
      <div *ngIf="!isAgreementChecked && googlePayVisible"
        style="position: absolute; inset: 0; background: rgba(200,200,200,0.65); border-radius: 6px; pointer-events: none;">
      </div>
    </div>

    <!-- Card Form -->
    <justifi-card-form></justifi-card-form>

    <!-- Billing Form: full address (AVS) or zip-only -->
    <div class="mt-4">
      <button *ngIf="isAvs" (click)="useAccountAddress()" class="btn btn-primary btn-lg w-100 fw-bold mt-2">Use Account Address</button>
      <justifi-billing-form-full *ngIf="isAvs"></justifi-billing-form-full>
      <justifi-card-billing-form-simple *ngIf="!isAvs"></justifi-card-billing-form-simple>
    </div>
  </div>
</justifi-modular-checkout>

